import React from 'react';

// Shared emoji list — used by the article modal and the new-list dialog.
export const EMOJI_OPTIONS = [
  '🛒','🍎','🍊','🍋','🍇','🍓','🫐','🍒','🍑','🥭','🍍','🥝','🍌','🍉','🍈',
  '🥦','🥕','🧅','🧄','🥔','🍅','🫑','🥒','🌽','🍄','🥬','🫒','🫛','🥑',
  '🥩','🍗','🥚','🧀','🥛','🧈','🍳','🥓','🌭','🍖',
  '🍞','🥐','🥖','🫓','🥨','🧁','🍰','🎂','🍮','🍩',
  '🍝','🍜','🍲','🥣','🍱','🥡','🫙','🥫','🍯','🫕',
  '🧃','🥤','🍺','🍻','🥂','🍷','🧉','☕','🍵','🧊',
  '🧴','🧻','🪥','🧹','🧺','🫧','🪣','🧽','🪒','🛁',
  '💊','🩺','🌿','🫚','🧂','🌶️','🍬','🍫','🧇','🏠',
  '🍕','🎉','🎁','🕯️','🔋','🌙','⭐','❤️','🔥','✨',
];

interface EmojiPickerProps {
  value: string;
  onChange: (emoji: string) => void;
  disabled?: boolean;
  label?: string;
}

export const EmojiPicker: React.FC<EmojiPickerProps> = ({ value, onChange, disabled, label = 'Emoji' }) => {
  const handlePaste = (e: React.ChangeEvent<HTMLInputElement>) => {
    const first = Array.from(e.target.value).find((ch) => ch.trim() !== '');
    if (first) onChange(first);
    e.target.value = '';
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-1.5">
        <label className="text-sm font-medium text-gray-700">{label}</label>
        <span className="flex items-center justify-center w-9 h-9 rounded-xl bg-primary/10 text-2xl leading-none">{value}</span>
      </div>

      <div className="grid grid-cols-8 gap-1 max-h-32 overflow-y-auto p-2 border border-gray-200 rounded-xl bg-gray-50 [scrollbar-width:thin]">
        {EMOJI_OPTIONS.map((emoji, i) => (
          <button
            key={i}
            type="button"
            disabled={disabled}
            onClick={() => onChange(emoji)}
            className={`flex items-center justify-center w-8 h-8 rounded-lg text-lg transition-all duration-150 hover:bg-white hover:shadow-soft ${
              value === emoji ? 'bg-white shadow-soft ring-2 ring-primary scale-110' : ''
            }`}
          >
            {emoji}
          </button>
        ))}
      </div>

      <input
        type="text"
        value=""
        onChange={handlePaste}
        disabled={disabled}
        placeholder="… ou collez n'importe quel emoji"
        className="w-full mt-2 text-sm bg-white border border-gray-200 rounded-lg px-3 py-2 placeholder:text-gray-400 text-gray-700 focus:outline-none focus:ring-2 focus:ring-primary/40 transition-all"
      />
    </div>
  );
};
